// Cross-origin window.top access throws only when embedded in the Admin iframe; treat that as embedded.
export const isEmbedded = (() => {
  try {
    return window.top !== window.self
  } catch {
    return true
  }
})()

// Served at the domain root when standalone, or under /kdsapp when hosted by ASP.NET.
export const getRouterBasename = (): string => {
  const path = window.location.pathname
  return path === '/kdsapp' || path.startsWith('/kdsapp/') ? '/kdsapp' : '/'
}
